"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Overlay = exports.Backdrop = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var openedCss = (0, _styledComponents.css)(["opacity:1;"]);
var closedCss = (0, _styledComponents.css)(["opacity:0;"]);
var states = {
  entering: openedCss,
  entered: openedCss,
  exiting: closedCss,
  exited: closedCss
};

var Backdrop = _styledComponents["default"].div.withConfig({
  displayName: "Overlaystyles__Backdrop",
  componentId: "sc-1l703fg-0"
})(function (_ref) {
  var state = _ref.state;
  return (0, _styledComponents.css)(["background-color:", ";bottom:0;left:0;position:absolute;right:0;top:0;transition:all ", "ms ease;", ";"], _tokens["default"].overlay.backdrop.backgroundColor, _tokens["default"].overlay.animationDuration, states[state]);
});

exports.Backdrop = Backdrop;

var Overlay = _styledComponents["default"].div.withConfig({
  displayName: "Overlaystyles__Overlay",
  componentId: "sc-1l703fg-1"
})(function (_ref2) {
  var zIndex = _ref2.zIndex;
  return (0, _styledComponents.css)(["bottom:0;left:0;position:fixed;right:0;top:0;", ""], zIndex ? "z-index: ".concat(zIndex) : null);
});

exports.Overlay = Overlay;
//# sourceMappingURL=Overlay.styles.js.map